(function () {
  var root = document.querySelector('[data-followswiss-wichtig-warning]');
  if (!root) return;

  var SEEN_KEY = 'followswiss_wichtig_popup_seen';

  /* Bewusst nur sessionStorage, kein Cookie-Fallback: ein Cookie ohne
     Max-Age lebt geräteweit bis der Browser komplett geschlossen wird und
     würde sich auf einem gemeinsam genutzten Gerät (Kiosk, Familien-PC) auf
     die nächste Person übertragen, die die Warnung nie gesehen hat. Ist
     sessionStorage nicht verfügbar (z. B. Safaris privates Surfen), wird
     die Warnung stattdessen bei jedem Aufruf erneut gezeigt (fail-open). */
  function hasSeenWarning() {
    try {
      return !!(window.sessionStorage && sessionStorage.getItem(SEEN_KEY));
    } catch (e) {
      return false;
    }
  }

  function markWarningSeen() {
    try {
      if (window.sessionStorage) sessionStorage.setItem(SEEN_KEY, '1');
    } catch (e) {}
  }

  if (hasSeenWarning()) return;

  var checkbox = root.querySelector('[data-followswiss-wichtig-checkbox]');
  var countEl = root.querySelector('[data-followswiss-wichtig-count]');
  var timerRow = root.querySelector('[data-followswiss-wichtig-timer]');
  var countdown = 10;
  var tick = null;
  var showTimeoutId = null;

  function resetState() {
    if (tick) {
      clearInterval(tick);
      tick = null;
    }
    root.classList.remove('is-visible', 'is-ready');
    document.body.style.overflow = '';
    countdown = 10;
    if (countEl) countEl.textContent = countdown;
    if (checkbox) {
      checkbox.disabled = true;
      checkbox.checked = false;
    }
    if (timerRow) timerRow.hidden = false;
  }

  function showModal() {
    root.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    tick = setInterval(function () {
      countdown -= 1;
      if (countEl) countEl.textContent = countdown;

      if (countdown <= 0) {
        clearInterval(tick);
        tick = null;
        root.classList.add('is-ready');
        if (checkbox) checkbox.disabled = false;
        if (timerRow) timerRow.hidden = true;
      }
    }, 1000);
  }

  function hideModal() {
    if (tick) {
      clearInterval(tick);
      tick = null;
    }
    root.classList.remove('is-visible');
    document.body.style.overflow = '';
    markWarningSeen();
  }

  if (checkbox) {
    checkbox.addEventListener('change', function () {
      if (checkbox.checked && !checkbox.disabled) {
        checkbox.disabled = true;
        hideModal();
      }
    });
  }

  /* Escape schliesst das Modal nur, wenn die 10-Sekunden-Wartezeit bereits
     abgelaufen ist (dieselbe Bedingung wie bei der Checkbox) — so bleibt
     die erzwungene Lesezeit erhalten, aber das Modal hat einen zweiten,
     von der Checkbox unabhängigen Ausgang, falls diese aus irgendeinem
     Grund nicht im DOM vorhanden ist. */
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-visible') && root.classList.contains('is-ready')) {
      hideModal();
    }
  });

  // Ohne Checkbox gäbe es keinen Weg, das Modal je wieder zu schliessen —
  // dann lieber gar nicht erst öffnen, statt die Seite zu sperren.
  if (checkbox) {
    showTimeoutId = setTimeout(showModal, 8000);
  }

  /* Verlässt der Nutzer die Seite während der 10-Sekunden-Wartezeit und
     kehrt über den Zurück-Button zurück, kann der Browser die Seite aus
     dem bfcache wiederherstellen statt sie neu zu laden — der zuvor
     eingefrorene Countdown-Timer und die Body-Scroll-Sperre würden sonst
     inkonsistent bleiben. Bei einer bfcache-Wiederherstellung wird der
     komplette Ablauf sauber zurückgesetzt und neu gestartet. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    resetState();
    if (hasSeenWarning()) return;
    clearTimeout(showTimeoutId);
    if (checkbox) {
      showTimeoutId = setTimeout(showModal, 8000);
    }
  });
})();